import { useTranslation } from "react-i18next";
import SolutionJourneySection from "./SolutionJourneySection";
import { ModuleProps } from "../types";
import { useSolutionIndividualData } from "../hooks/useSolutionIndividualData";
import { BottomBar } from "../../ParticipationFlow/components/bottom-bar";

function SolutionModule(props: ModuleProps) {
  const { t } = useTranslation();
  const solutionIndividualData = useSolutionIndividualData(props);

  return (
    <>
      {solutionIndividualData.dynamicJourneyData.map(
        (dynamicJourneyItem, index) => (
          <div
            className="page page-items"
            key={`${dynamicJourneyItem.id}-${index}`}
          >
            <div className="content">
              <div className="content-header solution-journey">
                <div className="title">
                  {t("individualPdfReport.solutionJourney", "Solution Journey")}
                </div>
              </div>

              <SolutionJourneySection
                journey1={solutionIndividualData.commonJourneyData[0]}
                journey2={solutionIndividualData.commonJourneyData[1]}
                journey3={solutionIndividualData.commonJourneyData[2]}
                activeJourneyId={dynamicJourneyItem.journeyId}
                activeJourneyItemId={dynamicJourneyItem.id}
                title={`${dynamicJourneyItem.label} - ${dynamicJourneyItem.secondaryLabel}`}
                question={dynamicJourneyItem.question.text || "N/A"}
                answer={dynamicJourneyItem.question.answer || "N/A"}
                color={dynamicJourneyItem.journeyColor}
              />
            </div>

            <div className="footer">
              <BottomBar />
            </div>
          </div>
        )
      )}
    </>
  );
}

export default SolutionModule;
